
import { features } from 'bits/features'
import { Component, namespace, Vue } from 'bits/vue'

const browser = namespace('browser')

@Component({})
export default class FeaturesContent extends Vue {
  @browser.Getter isPhone
  @browser.Getter isBiggerThanTabletLandscape
  features = features

  get featuresSectionClass(): object {
    return {
      'mobile-view': this.isPhone,
      'tablet-view': !this.isBiggerThanTabletLandscape,
      wrapper: true,
    }
  }
}
